import * as React from 'react';
import { ProductForSaleDTO, ProductGroupForSaleDTO, ValueButtonSize } from 'core/api';
import { Separator } from '@chakra-ui/react';
import { ProductButton, ProductButtonProps } from './ProductButton';
import { ScrollableGrid } from 'pos/ui';
import { ProductsSelection } from './ProductSelectionState';

export function LargeDeviceSearchByProductGroup({
	productGroupRows,
	selection,
	onGroupSelected,
	buttonsSize,
	onProductSelected
}: {
	productGroupRows: number;
	selection: ProductsSelection;
	onGroupSelected: (group: ProductGroupForSaleDTO) => Promise<void>;
	buttonsSize: ValueButtonSize;
	onProductSelected: (product: ProductForSaleDTO) => Promise<Result>;
}) {

	const largeDeviceSizes: Record<ValueButtonSize, ProductButtonProps<any>['size']> = {
		[ValueButtonSize.Small]: 'sm',
		[ValueButtonSize.Medium]: 'md',
		[ValueButtonSize.Large]: 'lg'
	};

	const size = largeDeviceSizes[buttonsSize];

	// OJO: Esto sería discutible. Se podría hacer que el tamaño de botón sólo afectara a la parte de productos (y muchas veces se ha planteado eso),
	// pero de momento hacemos que el tamaño sea el mismo para que estén todos alineados. En cualquier caso, si quisiéramos cambiarlo para que las
	// familias tengan siempre un tamaño fijo (por ejemplo, sm), sería fácil cambiarlo aquí.
	const groups = selection.groups.map(x => <ProductButton key={x.Id} value={x} size={size} selected={x.Id === selection.selectedGroup?.Id && x.Type === selection.selectedGroup?.Type} onClick={onGroupSelected} />);

	const products = selection.products.map(x => <ProductButton key={x.Id} size={size} disabled={!x.IsAvailable} value={x} onClick={onProductSelected} />);

	return (
		<>
			<ScrollableGrid rows={productGroupRows} items={groups} buttonSize={size} />
			<Separator width={'full'} borderColor={'transparent'} bg={{ base: '{colors.neutral.300}', _dark: '{colors.neutral.300}' }} height={'1.25px'} />
			<ScrollableGrid items={products} buttonSize={size} />
		</>
	);
}

export const PhoneSearchByProductGroup = React.memo(function PhoneSearchByProductGroup({
	mode,
	selection,
	onGroupSelected,
	buttonsSize,
	onProductSelected
}: {
	mode: 'groups' | 'products' | 'subgroup',
	selection: ProductsSelection;
	onGroupSelected: (group: ProductGroupForSaleDTO) => Promise<void>;
	buttonsSize: ValueButtonSize;
	onProductSelected: (product: ProductForSaleDTO) => Promise<Result>;
}) {

	const phoneSizes: Record<ValueButtonSize, ProductButtonProps<any>['size']> = {
		// Small realmente no existe, sólo se usan Medium y Large, y se corresponden
		// con los tamaños phone-XX de ProductButton.
		[ValueButtonSize.Small]: 'phone-md',
		[ValueButtonSize.Medium]: 'phone-md',
		[ValueButtonSize.Large]: 'phone-lg'
	};

	const size = phoneSizes[buttonsSize];

	const items = mode === 'groups'
		? selection.groups.map(x => <ProductButton key={`${x.Id}.${mode}`} value={x} size={size} selected={x.Id === selection.selectedGroup?.Id && x.Type === selection.selectedGroup?.Type} onClick={onGroupSelected} />)
		: selection.products.map(x => <ProductButton key={`${x.Id}.${mode}`} value={x} size={size} disabled={!x.IsAvailable} onClick={onProductSelected} />);

	return <ScrollableGrid key={mode} items={items} buttonSize={size} rowGap='2' columnGap='1.5' />;

}, (prev, next) =>
	// Comparo sólo las cosas que pueden cambiar entre renders. Soy conservador con el caso de selection. Seguramente
	// haya partes que podría ignorar, pero voy a lo seguro y hago que cualquier cambio fuerce un render
	prev.mode === next.mode &&
	prev.selection === next.selection
);
